import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import './PageTransition.css';

// Simple fade-out / fade-in between routes. We don't pull in
// Framer Motion just for this — the perceived effect is identical
// from CSS classes toggled on pathname change, and ships ~50KB lighter.
//
// Caveat: this runs after the route swap, so very heavy pages may
// flicker briefly before the fade-in kicks in. For Heaven Sent's
// route sizes that's not visible.
export default function PageTransition({ children }) {
  const { pathname } = useLocation();
  const [stage, setStage] = useState('enter'); // 'enter' or 'enter-active'

  useEffect(() => {
    setStage('enter');
    // Next tick → flip to active so the transition runs.
    const id = requestAnimationFrame(() => setStage('enter-active'));
    return () => cancelAnimationFrame(id);
  }, [pathname]);

  return <div className={`page-transition page-transition--${stage}`}>{children}</div>;
}
